import './assets/css/tailwind.css'
import './assets/css/materialdesignicons.min.css'
import { Route,Routes } from 'react-router-dom';
import Index from './pages';
import Blog from './pages/blog';
import IndexTwo from './pages/index-two';
import IndexThree from './pages/index-three';
import IndexLight from './pages/index-light';
import AboutUs from './pages/aboutus';
import Pricing from './pages/pricing';
import Services from './pages/services';
import BlogDetails from './pages/blog-detail';
import Helpcenter from './pages/helpcenter';
import Login from './pages/login';
import Signup from './pages/signup';
import ResetPassword from './pages/reset-password';
import Terms from './pages/terms';
import Privacy from './pages/privacy';
import Error from './pages/error';
import Contact from './pages/contact';

import { useEffect } from "react";
import posthog from "posthog-js"; // If you install it via npm: npm install posthog-js


function App() {
  useEffect(() => {
    posthog.init("phc_whdGQQZjVSBEq82xoB8Z575nhVUsYyBrgbTHN8tR4G9", {
        api_host: "https://eu.i.posthog.com",
        person_profiles: "identified_only",
    });
}, []);

  return (
    <Routes>
      <Route path='/' element={<IndexLight/>} />
 
      <Route path='/privacy-policy' element={<Privacy/>} />
      <Route path='/error' element={<Error/>} />
      <Route path='*' element={<Error/>} />
      
      
    </Routes>
  );
}

export default App;



